export default (Base = HTMLElement) =>
  class JsonDataMixin extends Base {
    get rootNode() {
      return this.shadowRoot ?? this;
    }

    jsonFrom(selector, remove = true) {
      const node = this.rootNode.querySelector(selector);
      if (!node) return;
      if (remove) {
        node.remove();
      }
      return JSON.parse(node.textContent);
    }
  };
